import { render } from "./ScpmChartDetail.vue?vue&type=template&id=956365c0&scoped=true"
import script from "./ScpmChartDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ScpmChartDetail.vue?vue&type=script&setup=true&lang=js"

import "./ScpmChartDetail.vue?vue&type=style&index=0&id=956365c0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-956365c0"],['__file',"src/components/scpm/common/ScpmChartDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "956365c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('956365c0', __exports__)) {
    api.reload('956365c0', __exports__)
  }
  
  module.hot.accept("./ScpmChartDetail.vue?vue&type=template&id=956365c0&scoped=true", () => {
    api.rerender('956365c0', render)
  })

}


export default __exports__